/**
 * Service provider logo settings.
 * Each named export is a provider id, with related carrier data
 */

export const ups = {
  code: '',
  width: '21',
  height: '24',
}

export const dhl = {
  code: '',
  width: '150',
  height: '24',
}

export const usps = {
  code: '',
  width: '145',
  height: '24',
}

export const fedex = {
  code: 'FDXE',
  width: '87',
  height: '24',
}
